/**
 * BlogARBlogPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait BlogARBlogPage
 */

import { useBlogARBlogPageLogic } from '@/hooks/traits/useBlogARBlogPageLogic';
import type { BlogARBlogPageConfig } from '@/hooks/traits/useBlogARBlogPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { BlogARBlogView as BlogARBlogViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { BlogARBlogHeaderView } from '@/components/traits/BlogARBlogHeaderView';
import { BlogARBlogPostsView } from '@/components/traits/BlogARBlogPostsView';
import { BlogARBlogFooterView } from '@/components/traits/BlogARBlogFooterView';
import { BlogARBlogHeroView } from '@/components/traits/BlogARBlogHeroView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface BlogARBlogPageViewProps {
  config?: Partial<BlogARBlogPageConfig>;
}

export function BlogARBlogPageView({ config: propsConfig }: BlogARBlogPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useBlogARBlogPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['BlogARBlogView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="BlogAR" trait="BlogARBlogPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="BlogARBlogPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><BlogARBlogHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogARBlogHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogARBlogPostsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogARBlogFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default BlogARBlogPageView;
